routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider) {
    $stateProvider
        .state('home.procedureList', {
            url: "procedure-list",
            template: `<procedure-list sh-ctrl="shCtrl"></procedure-list>`
        })
        .state('home.procedureListSlug', {
            url: "product-list-slug/{procedureSlug}",
            template: `<procedure-list sh-ctrl="shCtrl"></procedure-list>`
        });

}

export default routesConfig;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/catalog/procedure-list/procedure-list.config.js
 **/